import { Image, ImageInterface } from "./image";

export interface GeoFeatureInterface {
  id?: number;
  type?: string;
  geometry: {
      type?: string;
      coordinates: any[];
  };
  properties?: {
      name?: string;
      description?: string;
      color?: string;
      images?: ImageInterface[];
  };
}

export interface GeoFeaturesInterface {
  type: string;
  features: GeoFeatureInterface[];
}

/**
 * Class used as a base for geo features
 */
export class GeoFeatureBase {
  id: number;
  name?: string;
  description?: string;
  featureType: string;
  geometryType: string;
  coordinates: any[];
  color?: string;
  images: Image[] = [];
  hasChanges = false;

  constructor(
    options: GeoFeatureInterface
  ) {
    this.id = options.id || 0;
    this.name = options.properties?.name || '';
    this.description = options.properties?.description || '';
    this.featureType = options.type || 'Feature';
    this.geometryType = options.geometry.type || '';
    this.coordinates = options.geometry.coordinates;
    this.color = options.properties?.color || '';
    options.properties?.images?.forEach(image => {
      this.images.push(new Image(image));
    })
  }

  toJson(): GeoFeatureInterface {
    return {
      "id": this.id,
      "type": this.featureType,
      "properties": {
        "name": this.name,
        "description": this.description,
        "color": this.color,
        "images": this.images
      },
      "geometry": {
        "type": this.geometryType,
        "coordinates": this.coordinates
      }
    };
  }

  equals(obj: GeoFeatureBase): boolean {
    return this.name === obj.name &&
      this.description === obj.description &&
      this.geometryType === obj.geometryType &&
      this.coordsEqual(this.coordinates, obj.coordinates) &&
      this.color === obj.color;
  }

  coordsEqual(arr: any[], other: any[]): boolean {
    return arr.length === other.length &&
        arr.every((val, index) => val === other[index]);
  }
}

